var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { theme } from '../../theme';
import { H2 } from '../../atoms/headers';
import { CaptionLarge } from '../../atoms/special/Captions/Captions';
import { InfoIcon } from '../../atoms/icons/20X20/InfoIcon';
import { ProjectedAnnualQuoteStyle } from './ProjectedAnnualQuoteStyle';
import { LabelSmall } from '../../labels';
export var ProjectedAnnualQuote = function (_a) {
    var title = _a.title, figure = _a.figure, _b = _a.onInfoClick, onInfoClick = _b === void 0 ? null : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.subTitle, subTitle = _d === void 0 ? '' : _d;
    return (_jsxs(ProjectedAnnualQuoteStyle, __assign({ className: className }, { children: [_jsxs("div", __assign({ className: "text-wrapper" }, { children: [_jsx(LabelSmall, __assign({ className: "title" }, { children: title })), _jsx("div", __assign({ className: "figure" }, { children: _jsx(H2, __assign({ className: "figure-text" }, { children: figure })) })), subTitle && _jsx(CaptionLarge, __assign({ className: "caption" }, { children: subTitle }))] })), onInfoClick && (_jsx("div", __assign({ className: "icon-wrapper", onClick: onInfoClick }, { children: _jsx(InfoIcon, { fill: theme.primaryColours.white.main }) })))] })));
};
